import {BenefitInfoContainer} from './components';

export default BenefitInfoContainer;
